import PlayVideoContainer from './play-video.container'

export default PlayVideoContainer
